export interface Customer {
    id: number;
    customerType: number;
    status: number;
    rif: string;
    name: string;
    category?: {
        id: number;
        status: number;
        name: string;
    };
}

export const CAV_CUSTOMER = 2;
